import Vue from "vue";

export default new Vue({
  methods: {
    notificar(mensagem) {
      this.$emit("EXIBIR_MENSAGEM", mensagem);
    },

    onNotificar(callback) {
      this.$on("EXIBIR_MENSAGEM", callback);
    },

    erro(mensagem, error) {
      this.$emit("EXIBIR_MENSAGEM_ERRO", { mensagem, error });
    },

    onErro(callback) {
      this.$on("EXIBIR_MENSAGEM_ERRO", callback);
    },
  },
});
